import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useQuery } from "react-apollo-hooks";
import ReactMoment from "react-moment";
import NumberFormat from "react-number-format";
import { MANAGER_FEEHASUSER_DETAIL_LIST_QUERY } from "../Queries";

const PaymentHistory = ({ feeHasUserId, memberName }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  const { data, loading } = useQuery(MANAGER_FEEHASUSER_DETAIL_LIST_QUERY, {
    variables: { feeHasUser_id: feeHasUserId, skip: 0, first: 1000 },
    skip: !open,
    fetchPolicy: "network-only",
  });

  const details =
    data &&
    data.ManagerFeeHasUserDetailList &&
    data.ManagerFeeHasUserDetailList.feeHasUserDetails;

  return (
    <>
      <button
        className="btn btn-white btn-xs text-blue m-r-5"
        onClick={toggle}
      >
        납부내역
      </button>

      <Modal isOpen={open} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{memberName} 납부내역</ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <table className="table table-bordered table-striped m-b-0">
              <thead>
                <tr>
                  <th>일자</th>
                  <th>내용</th>
                  <th>납부액</th>
                  <th>미납</th>
                  <th>누적</th>
                </tr>
              </thead>
              <tbody>
                {(loading || !details || details.length === 0) && (
                  <tr>
                    <td colSpan={5} className="text-center">
                      {loading ? "불러오는 중..." : "납부내역이 없습니다."}
                    </td>
                  </tr>
                )}
                {details &&
                  details.map((d) => (
                    <tr key={d.id}>
                      <td>
                        <ReactMoment format="YYYY-MM-DD">
                          {d.createdAt}
                        </ReactMoment>
                      </td>
                      <td>{d.description}</td>
                      <td align="right">
                        <NumberFormat
                          value={d.feeValue}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </td>
                      <td align="right" className="text-red">
                        <NumberFormat
                          value={d.feeDefault}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </td>
                      <td align="right">
                        <NumberFormat
                          value={d.feeAmount}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PaymentHistory;
